interface Props {
  number: string;
  description: string;
  status: string;
  time: string;
  target: string;
  priority: string;
  calltype: string;
  line: string;
  caller: string;
  operator: string;
  operatorgroup: string;
}

const CustomerIncident = ({
  number,
  description,
  status,
  time,
  target,
  priority,
  calltype,
  line,
  caller,
  operator,
  operatorgroup,
}: Props) => {
  // const isTargetPastOrToday = (targetDate: string) => {
  //   const [day, month, year] = targetDate.split("-").map(Number);
  //   const targetDateObj = new Date(year, month - 1, day);
  //   const today = new Date();

  //   targetDateObj.setHours(0, 0, 0, 0);
  //   today.setHours(0, 0, 0, 0);

  //   return targetDateObj < today;
  // };

  // const containerClass = isTargetPastOrToday(target)
  //   ? "w-full text-red-500 border-b-2 border-gray-300 flex p-2 items-center text-sm hover:bg-gray-50"
  //   : priority === "P1"
  //   ? "w-full text-black bg-red-500 border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50"
  //   : "w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50";

  // // Translate line value to short label
  // let whatline = "FL";
  // if (line === "secondLine") {
  //   whatline = "SL";
  // }

  const isTargetPastOrToday = (targetDate: string) => {
    const [day, month, year] = targetDate.split("-").map(Number);
    const targetDateObj = new Date(year, month - 1, day);
    const today = new Date();

    targetDateObj.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return targetDateObj < today;
  };

  // Change line
  let whatline = "FL";
  if (line === "secondLine") {
    whatline = "SL";
  }

  const containerClass = isTargetPastOrToday(target)
    ? "w-full text-red-500 border-b-2 border-gray-300 flex p-2 flex items-center text-sm hover:bg-gray-50"
    : priority === "P1"
    ? "w-full text-black bg-red-500 border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50"
    : "w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50";

  return (
    // <div className={containerClass}>
    //   <p className="w-1/12 text-center">{number}</p>
    //   <p className="w-2/12 text-left">{description}</p>
    //   <p className="w-1/12 text-center">{status}</p>
    //   <p className="w-1/12 text-center">{time}</p>
    //   <p className="w-1/12 text-center">{target}</p>
    //   <p className="w-1/12 text-center">{priority}</p>
    //   <p className="w-1/12 text-center">{calltype}</p>
    //   <p className="w-1/12 text-center">{whatline}</p>
    //   <p className="w-1/12 text-center">{caller}</p>
    //   <p className="w-1/12 text-center">{operator}</p>
    //   <p className="w-1/12 text-center">{operatorgroup}</p>
    // </div>
    <div className={containerClass}>
      <p className="w-2/12">{number}</p>
      <p className="w-3/12">{description}</p>
      <p className="w-2/12 text-left">{status}</p>
      <div className="w-2/12 flex flex-col text-nowrap justify-center">
        <p>
          <b>Target:</b> {target}
        </p>
        <p>
          <b>Tijd:</b> {time}
        </p>
        <p>
          <b>Prioritijd:</b> {priority}
        </p>
        <p>
          <b>Lijn:</b> {whatline}
        </p>
      </div>
      <div className="w-2/12 flex flex-col text-nowrap justify-center">
        <p>
          <b>Aanvrager:</b> {caller}
        </p>
        <p>
          <b>Operator:</b> {operator}
        </p>
      </div>
    </div>
  );
};

export default CustomerIncident;
